'use client';

/* eslint-disable react/no-array-index-key */
import Image from 'next/image';
import Carousel from '@sympla/sympla-components/Carousel';

import ImagePlaceholder from 'assets/imgs/img-placeholder.svg';

import {
  gallerySliderWrapperStyle,
  imgStyle,
  carouselPaginationStyle,
  carouselPaginationBulletStyle,
  carouselPaginationContainerStyle,
  galleryImageStyle,
  galleryImagePlaceholderStyle,
} from './GallerySlider.css';

interface GallerySliderProps {
  imagesUrl: string[];
}

function GallerySlider({ imagesUrl }: GallerySliderProps) {
  const createSlides = () => imagesUrl.map((src, index) => (
    <div key={`galley-slider-${imagesUrl}-${index}`} className={imgStyle}>
      <ImagePlaceholder className={galleryImagePlaceholderStyle} />

      <Image
        className={galleryImageStyle}
        src={src}
        alt={`Slide ${index}`}
        // fill
        loading={index > 1 ? 'lazy' : 'eager'}
        priority={index < 1}
        width={1100}
        height={400}
        sizes="(max-width: 640px) 90vw, (max-width: 1000px) 96vw, 1100px"
      />
    </div>
  ));

  return (
    <div className={gallerySliderWrapperStyle}>
      <Carousel
        id="gallery-carousel"
        options={createSlides().map((slide) => ({ slide }))}
        settings={{
          slidesPerView: 1,
          spaceBetween: 16,
          pagination: {
            el: `.${carouselPaginationStyle}`,
            type: 'bullets',
            clickable: true,
            renderBullet(index: number, className: string) {
              return `<span class="${className} ${carouselPaginationBulletStyle}"></span>`;
            },
          },
          lazyPreloadPrevNext: 2,
          // autoplay: {
          //   delay: 3000,
          // },
        }}
      />
      <div className={carouselPaginationContainerStyle}>
        <div className={`${carouselPaginationStyle}`} />
      </div>
    </div>
  );
}

export default GallerySlider;
